/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Breadcrumbs, Button, Link, Typography } from "@mui/material";
import manWomanBoxes from "assets/supergasbras/images/manWomanBoxes.svg";

import AddNewAreaModal from "components/ProductsAndCoverageHeader/AddNewAreaModal";

import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Styled from "./styles";

interface ProductsAndCoverageHeaderProps {
  dealer: {
    id: string;
    name: string;
  };
  title: string;
  titleButton: string;
  onClick?: () => void;
}

const ProductsAndCoverageHeader = ({
  dealer,
  title,
  titleButton,
  onClick,
}: ProductsAndCoverageHeaderProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isAddNewAreaModalVisible, setIsAddNewAreaModalVisible] =
    useState(false);

  const handleAddNewAreaModalVisibility = () => {
    setIsAddNewAreaModalVisible((state) => !state);
    onClick?.();
  };

  const backPage = (index: number) => navigate(index);

  return (
    <Styled.Container>
      <AddNewAreaModal
        dealerId={dealer.id}
        isOpen={isAddNewAreaModalVisible}
        onClose={handleAddNewAreaModalVisibility}
      />
      <Styled.Image src={manWomanBoxes} aria-label={t("manWomanBoxes")} />

      <Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" onClick={() => backPage(-2)}>
          {t("dealers")}
        </Link>
        <Link underline="hover" color="inherit" onClick={() => backPage(-1)}>
          {dealer.name}
        </Link>
        <Typography color="text.primary" variant="h5">
          {title}
        </Typography>
      </Breadcrumbs>
      <Button
        sx={{ marginLeft: "auto" }}
        variant="outlined"
        onClick={handleAddNewAreaModalVisibility}
      >
        {titleButton}
      </Button>
    </Styled.Container>
  );
};

export default ProductsAndCoverageHeader;
